import * as CONST from '../ActionTypes';

const initialState = {
  productOptionList: [],
  productOption: {},
  isSuccess: false,
  isFailure: false,
  errorMessage: '',
  query: {
    currentPage: 0,
    itemsPerPage: 10,
    sort: 'created_at',
    isAsc: false,
    search: '',
  },
};

function productOption(state = initialState, action) {
  switch (action.type) {
    // -----------------
    // カテゴリーカテゴリー一覧取得
    // -----------------
    case CONST.GET_PRODUCT_OPTION_LIST_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          productOptionList: action.payload,
        },
      );
    case CONST.GET_PRODUCT_OPTION_LIST_FAILURE:
      return Object.assign(
        {},
        state,
        {
          productOptionList: [],
        },
      );
    // -----------------
    // カテゴリー詳細取得
    // -----------------
    case CONST.GET_PRODUCT_OPTION_DETAIL_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          productOption: action.payload,
        },
      );
    case CONST.GET_PRODUCT_OPTION_DETAIL_FAILURE:
      return Object.assign(
        {},
        state,
        {
          productOption: {},
        },
      );
    // -----------------
    // カテゴリー削除
    // -----------------
    case CONST.DELETE_PRODUCT_OPTION_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          isSuccess: true,
          isFailure: false,
          errorMessage: '',
        },
      );
    case CONST.DELETE_PRODUCT_OPTION_FAILURE:
      return Object.assign(
        {},
        state,
        {
          isSuccess: false,
          isFailure: true,
          errorMessage: action.payload,
        },
      );
    // -----------------
    // 結果フラグクリア
    // -----------------
    case CONST.CLEAR_PRODUCT_OPTION_RESULT_FLG:
      return Object.assign(
        {},
        state,
        {
          isSuccess: false,
          isFailure: false,
          errorMessage: '',
        },
      );
    default:
      return state;
  }
}

export default productOption;
